var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChatCentered = function SvgIconChatCentered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 5.5V17h5.33a1.74 1.74 0 0 1 1.495.855L12 19.815l1.175-1.96A1.74 1.74 0 0 1 14.67 17H20V5.5zm10.034 12.866.638.382v-.008zm.639.375v.007l.007.004.212.128.005-.008zm.147.259h5.43A1.75 1.75 0 0 0 22 17.25v-12a1.75 1.75 0 0 0-1.75-1.75H3.75A1.75 1.75 0 0 0 2 5.25v12A1.75 1.75 0 0 0 3.75 19h5.43l1.315 2.195.006.01a1.76 1.76 0 0 0 2.998 0l.006-.01z",
    clipRule: "evenodd"
  })));
};
export default SvgIconChatCentered;